__turbopack_context__.v({
  "root": "ScrollToTopButton-module-scss-module__dQtMHW__root",
  "visible": "ScrollToTopButton-module-scss-module__dQtMHW__visible",
});
